import React from 'react';

import { isTabletOrWeb } from 'utils/responsiveness';

import ActionButton from 'components/CustomButtons/ActionButton';
import { DialogProps } from 'components/Dialog/types';

import styles from './styles';

// @ts-ignore
type Props = Pick<
    DialogProps,
    'cancelButtonTitle' | 'handleCancelPress' | 'cancelButtonFillColor',
    | 'cancelButtonBordered'
    | 'actionButtonTitle'
    | 'handleActionButtonPress'
    | 'actionButtonFillColor'
    | 'actionButtonBordered'
    | 'actionButtonStyle'
    | 'cancelButtonStyle'
    | 'revertButton'
>;

export function DialogButtons({
    cancelButtonTitle,
    handleCancelPress,
    cancelButtonFillColor,
    cancelButtonBordered,
    actionButtonTitle,
    actionButtonTextStyle,
    handleActionButtonPress,
    actionButtonFillColor,
    actionButtonBordered,
    actionButtonStyle,
    cancelButtonStyle,
    cancelButtonTextStyle,
    revertButtons,
    actionButtonTestID,
    closeButtonTestID,

    cancelButtonAccessibilityLabel,
    actionButtonAccessibilityLabel,
}: Props) {
    const cancelButton = cancelButtonTitle && handleCancelPress && (
        <ActionButton
            testID={closeButtonTestID}
            title={cancelButtonTitle}
            onPress={handleCancelPress}
            fillColor={cancelButtonFillColor}
            buttonStyle={[
                styles.button,
                !!(isTabletOrWeb && !revertButtons && actionButtonTitle) &&
                    styles.tabletButtonIndent,
                cancelButtonBordered && styles.borderedButton,
                cancelButtonStyle,
            ]}
            buttonTextStyle={cancelButtonTextStyle}
            accessibilityLabel={cancelButtonAccessibilityLabel}
        />
    );

    const actionButton = actionButtonTitle && (
        <ActionButton
            testID={actionButtonTestID}
            title={actionButtonTitle}
            onPress={handleActionButtonPress}
            fillColor={actionButtonFillColor}
            buttonStyle={[
                styles.button,
                !!(isTabletOrWeb && revertButtons && cancelButton) &&
                    styles.tabletButtonIndent,
                actionButtonBordered && styles.borderedButton,
                actionButtonStyle,
            ]}
            buttonTextStyle={actionButtonTextStyle}
            accessibilityLabel={actionButtonAccessibilityLabel}
        />
    );

    const firstButton = revertButtons ? actionButton : cancelButton;
    const secondButton = revertButtons ? cancelButton : actionButton;

    return (
        <>
            {firstButton}
            {secondButton}
        </>
    );
}
